var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRedAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF586D",
  d: "M22.634 16.995 13.973 2.287A2.52 2.52 0 0 0 11.769 1c-.916 0-1.74.477-2.217 1.3L1.366 16.995a2.7 2.7 0 0 0-.026 2.665c.464.836 1.302 1.34 2.243 1.34h16.834c.94 0 1.779-.504 2.243-1.34a2.7 2.7 0 0 0-.026-2.665Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF586D",
  d: "M13 17c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF586D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12 13.801v-8"
})));
export default SvgRedAlert;